module.exports = __webpack_public_path__ + "static/media/service-charge.a496c64d.svg";